import { render } from "./InstanceForm.vue?vue&type=template&id=65610ab6&scoped=true"
import script from "./InstanceForm.vue?vue&type=script&lang=js"
export * from "./InstanceForm.vue?vue&type=script&lang=js"

import "./InstanceForm.vue?vue&type=style&index=0&id=65610ab6&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-65610ab6"]])

export default __exports__